import { OARankingCard } from './OARankingCard'
import { useOARankings } from './useOARankings'

export function OARankingDashboard() {
  const widgets = useOARankings()

  return (
    <div className="space-y-6">
      <div className="flex flex-col gap-1">
        <h1 className="text-2xl font-bold tracking-tight">控制台</h1>
        <p className="text-muted-foreground">员工业绩与部门业绩排行榜</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {widgets.map(({ widget, data, isLoading, isError, error, refetch }, index) => (
          <OARankingCard
            key={index}
            widget={widget}
            rows={data}
            isLoading={isLoading}
            isError={isError}
            error={error as Error | null}
            onRetry={refetch}
          />
        ))}
      </div>
    </div>
  )
}
